import React from "react";
import { domain } from "../../../constants/Branding";
import { getEnvVariable } from "../../../constants/brandConfig";
import LoginPageBanner from "../../../assets/login_page_banner.webp";
import SignUpForm from "./SignUpForm";

interface SignUpModalProps {
  onClose: () => void;
  onSuccess?: () => void;
}

const SignUpModal: React.FC<SignUpModalProps> = ({ onClose, onSuccess }) => {
  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 p-4"
      onClick={onClose}
      role="presentation"
    >
      <div
        className="flex w-full max-w-4xl max-h-[90vh] overflow-hidden rounded-lg shadow-xl bg-white"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label="Sign up"
      >
        {/* Left: dark panel with logo */}
        <div
          className="hidden md:flex flex-[0_0_45%] relative items-center justify-center min-h-[480px] bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url(${LoginPageBanner})` }}
        >
          <div className="absolute inset-0 bg-black/60" />
          <div className="relative z-10 flex items-center justify-center p-8">
            <img
              src={getEnvVariable(domain, "logo")}
              alt="Logo"
              className="max-h-[120px] w-auto object-contain"
            />
          </div>
        </div>

        {/* Right: golden-yellow form panel */}
        <div className="flex flex-1 flex-col bg-goldenYellow min-h-[480px] max-h-[90vh] relative">
          <button
            type="button"
            onClick={onClose}
            className="absolute top-3 right-3 z-10 w-10 h-10 flex items-center justify-center bg-black text-white rounded hover:opacity-90 transition-opacity"
            aria-label="Close"
          >
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>

          <div className="flex flex-col flex-1 overflow-y-auto px-6 py-8 pt-14">
            <div className="flex justify-center">
              <SignUpForm onSuccess={onSuccess} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignUpModal;
